import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../services/user.service";
import { UserTagService } from "../services/user-tag.service";
import { User } from "../models/user";
import { CompanylinkedService } from "../services/companylinked.service";
import { CompanyLinked } from "../models/companylinked";
import swal from "sweetalert2";
import { NuevoCompany } from "../tables/listcompany/listcompany.component";
import { FolderService } from "../services/folder.service";
import { Folder } from "../models/folder";
import { CategoriesService } from "../services/categories.service";
import { Methods } from "../shared/methods";
import { LocationService } from "../services/location.service";
import { ConfigService } from "../services/config.service";
import Swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: "app-customers",
  templateUrl: "./customers.component.html",
  styleUrls: ["./customers.component.css"],
  providers: [
    UserService,
    FolderService,
    CompanylinkedService,
    UserTagService,
    CategoriesService,
  ],
})
export class CustomersComponent implements OnInit {
  public mtds: Methods = new Methods();
  public activos = 1;
  name: string;
  animal: string;

  public privilegio;
  sexos = [
    { value: "1", viewValue: "Hombre" },
    { value: "0", viewValue: "Mujer" },
  ];
  frequencies = [
    { value: "DAILY", viewValue: "Daily" },
    { value: "WEEKLY", viewValue: "Weekly" },
    { value: "MONTHLY", viewValue: "Monthly" },
    { value: "NEVER", viewValue: "Never" },
  ];
  public customers: string[][];
  public cargando = false;
  public pacientes: Array<User>;
  public identity;
  public token;
  public pages;
  public pagePrev;
  public pageNext;
  public loading;
  public loadingbar = false;
  public filter = 0;
  public order = 0;
  public searchString;
  public user;
  public status_user;
  public companySelected;
  public tags = [];
  public usersTags = [];
  public selectId: null;
  public gettingUsersTags = false;

  public allCategories;
  public categories: any[] = [];
  public userCategories: number[] = [];
  public options: Array<any> = [];
  public idUser: any;

  constructor(
    public dialog: MatDialog,
    private titleService: Title,
    private _route: ActivatedRoute,
    private _tagServices: UserTagService,
    private _router: Router,
    private _folderService: FolderService,
    private _companylinkedService: CompanylinkedService,
    private _userService: UserService,
    private _cattegorieServices: CategoriesService,
    private _config: ConfigService
  ) {
    this.titleService.setTitle("Customers");
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.getCategories();
  }

  ngOnInit() {
    this.cargando = true;
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      this._config.getConfig("customers").subscribe(
        (r) => {
          if (r.data) {
            this.options = JSON.parse(r.data.data);
          } else {
            this.options = this.mtds.colopt(
              [
                "ID",
                "Rep name",
                "Company Name",
                "Name",
                "Country",
                "email",
                "Average Rating",
                "Status",
                "Actions",
              ],
              [false]
            );
          }
          let defaultfilters = localStorage.getItem("filtercustomercategories");

          if (defaultfilters) {
            this.userCategories = JSON.parse(defaultfilters);
            // console.log(JSON.parse(defaultfilters));
          }
          this.getCustomers();
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
    }
  }

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig("customers", this.options).subscribe((r) => {
      console.log(r);
    });
  }

  cambiarActivos() {
    if (this.activos === 1) {
      this.activos = 0;
    } else {
      this.activos = 1;
    }

    this.getAllPacientes();
  }

  boton(e) {
    // console.log(e);
    switch (e.evento) {
      case "show": {
        this._router.navigate(["/pages/user/" + e.id]);
        break;
      }
      case "delete": {
        this.deleteFolderfirst(e.id);
        break;
      }
      case "chat": {
        this.idUser = e.id;
        $("#modalNotes").modal("show");
        break;
      }
    }
  }

  close() {
    $("#modalNotes").modal("hide");
    this.idUser = "";
  }

  getCustomers() {
    if (this.userCategories.length === 0) {
      this.getAllPacientes();
    } else {
      this.listUserCategories();
    }
  }

  getCategories() {
    this._cattegorieServices.showAll().subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.allCategories = response.data;
          for (let item of response.data) {
            if (item.father === 0) {
              let padre = {
                id: item.id,
                father: item.father,
                name: item.name,
                sub: [],
              };
              this.categories.push(padre);
            }
          }

          for (let item of response.data) {
            if (item.father !== 0) {
              let hijo = {
                id: item.id,
                father: item.father,
                name: item.name,
              };
              for (let i of this.categories) {
                if (i.id === hijo.father) {
                  i.sub.push(hijo);
                  break;
                }
              }
            }
          }
          // console.log('Aquie merengues');
          // console.log(this.categories);
        } else {
          console.log("Error!");
        }
      },
      (error) => {
        console.log("Error!");
      }
    );
  }

  checkedAll(category_id) {
    for (let itemCat of this.allCategories) {
      if (!this.isAdded(itemCat.id) && itemCat.father === category_id) {
        return false;
      }
    }

    return true;
  }

  addCategoire(category, evento) {
    // console.log('Categoria: ');
    // console.log(category);
    // console.log('Evento: ');
    // console.log(evento);

    if (category.name !== "All") {
      if (!evento.checked) {
        let index = 0;
        for (let item of this.userCategories) {
          if (item === category.id) {
            this.userCategories.splice(index, 1);
          }
          index++;
        }
        console.log(category.father);
        if (category.father === 0) {
          for (let itemCat of this.allCategories) {
            if (this.isAdded(itemCat.id) && itemCat.father === category.id) {
              let index = 0;
              for (let i of this.userCategories) {
                if (itemCat.id === i) {
                  this.userCategories.splice(index, 1);
                  break;
                }
                index++;
              }
            }
          }
        }
      } else {
        this.userCategories.push(category.id);
        if (category.father === 0) {
          for (let item of category.sub) {
            this.userCategories.push(item.id);
          }
        }
      }
    } else if (category.name === "All" && !evento.checked) {
      for (let itemCat of this.allCategories) {
        if (this.isAdded(itemCat.id) && itemCat.father === category.father) {
          let index = 0;
          for (let i of this.userCategories) {
            if (itemCat.id === i) {
              this.userCategories.splice(index, 1);
              break;
            }
            index++;
          }
        }
      }
    } else if (category.name === "All" && evento.checked) {
      for (let itemCat of this.allCategories) {
        if (!this.isAdded(itemCat.id) && itemCat.father === category.father) {
          this.userCategories.push(itemCat.id);
        }
      }
    }

    console.log(this.userCategories);
    localStorage.setItem(
      "filtercustomercategories",
      JSON.stringify(this.userCategories)
    );
  }

  isAdded(id) {
    for (let i of this.userCategories) {
      if (id === i) {
        return true;
      }
    }
    return false;
  }

  isCheked(category) {
    if (category.name === "All") {
      return this.checkAll(category);
    } else {
      return this.isAdded(category.id);
    }
  }

  checkAll(category) {
    for (let item of this.categories) {
      if (item.id === category.father) {
        for (let i of item.sub) {
          if (!this.isAdded(i.id)) {
            return false;
          }
        }
        return true;
      }
    }
  }

  openTagModal(customerID) {
    this.gettingUsersTags = true;
    $("#tagModal").modal("show");
    this.selectId = customerID;
    this._tagServices.listTagsByUser(customerID).subscribe(
      (response) => {
        console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.usersTags = [];
          for (let item of response.data) {
            let data = {
              id: item.id,
              user: item.user.id,
              tag: item.userTag.id,
            };
            this.usersTags.push(data);
          }
        } else {
          this.closeTagModal();
          this.mtds.notifyError(response.msg, response.code);
        }
        this.gettingUsersTags = false;
      },
      (error) => {
        this.closeTagModal();
        this.gettingUsersTags = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  closeTagModal() {
    $("#tagModal").modal("hide");
    this.selectId = null;
    this.usersTags = [];
  }

  addTag(e, tag) {
    this.loadingbar = true;
    if (e.checked) {
      let data = {
        user_id: this.selectId,
        tag_id: tag,
      };
      this._tagServices.assignTag(data).subscribe(
        (response) => {
          if (response.status !== "success") {
            this.closeTagModal();
            this.mtds.notifyError(response.msg, response.code);
          }
          this.loadingbar = false;
        },
        (error) => {
          this.closeTagModal();
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    } else {
      for (let item of this.usersTags) {
        if (item.tag == tag) {
          this._tagServices.unAssignTag(item.id).subscribe(
            (response) => {
              if (response.status !== "success") {
                this.closeTagModal();
                this.mtds.notifyError(response.msg, response.code);
              }
              this.loadingbar = false;
            },
            (error) => {
              this.closeTagModal();
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
          break;
        }
      }
    }
  }

  checkTag(id) {
    for (let item of this.usersTags) {
      if (item.tag == id) {
        return true;
      }
    }
    return false;
  }

  deleteUser() {
    let id = $("#borrarUser").val();
    console.log(id + "aqui");
    this._userService.deleteUser(this.token, id).subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          // this._router.navigate(['/']);
          // this.getAllPacientes();
          alert("Done");
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        console.log(<any>error);
      }
    );
  }

  showSwal(type) {
    if (type === "success-message") {
      swal.fire({
      
        title: "Customer successfully added!",
        text: "",
        buttonsStyling: false,
        customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    } else if (type === "warning-message-and-confirmation") {
      swal.fire({
        title: "Are you sure?",
        text: "You will not be able to revert this!",
    
        showCancelButton: true,
       
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
          
            customClass:{
    confirmButton: 'btn btn-success'
            },
            buttonsStyling: false,
          });
        })
        ;
    } else if (type === "warning-message-and-cancel") {
      swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this imaginary file!",
      
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
       
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false,
      })
        .then(
          function () {
            swal.fire({
              title: "Deleted!",
              text: "Your imaginary file has been deleted.",
             
              customClass:{
    confirmButton: 'btn btn-success'
            },
              buttonsStyling: false,
            });
          },
          function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === "cancel") {
              swal.fire({
                title: "Cancelled",
                text: "Your imaginary file is safe :)",
             
                customClass:{
    confirmButton: 'btn btn-info'
            },
                buttonsStyling: false,
              });
            }
          }
        )
        ;
    } else if (type === "custom-html") {
      swal.fire({
        title: "HTML example",
        buttonsStyling: false,
        customClass:{
    confirmButton: 'btn btn-success'
            },
        html:
          "You can use <b>bold text</b>, " +
          '<a href="http://github.com">links</a> ' +
          "and other HTML tags",
      });
    } else if (type === "auto-close") {
      swal.fire({
        title: "Auto close alert!",
        text: "I will close in 2 seconds.",
        timer: 2000,
        showConfirmButton: false,
      })
        .then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === "timer") {
              console.log("I was closed by the timer");
            }
          }
        )
        ;
    } else if (type === "input-field") {
      swal.fire({
        title: "Input something",
        html:
          '<div class="form-group">' +
          '<input id="input-field" type="text" class="form-control" />' +
          "</div>",
        showCancelButton: true,
      
        customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },
        buttonsStyling: false,
      })
        .then(function (result) {
          swal.fire({
         
            html:
              "You entered: <strong>" + $("#input-field").val() + "</strong>",
           customClass:{
    confirmButton: 'btn btn-success'
            },
            buttonsStyling: false,
          });
        })
        ;
    }
  }

  openNuevoPaciente(): void {
    this.user = new User(
      1,
      "customer",
      "",
      "",
      "",
      "demo123",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      0,
      "",
      1,
      1,
      1,
      "",
      0,
      "",
      "",
      "",
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      "",
      "",
      "",
      ""
    );
    let dialogRef = this.dialog.open(NuevoPaciente, {
      width: "80%",
      data: { user: this.user, sexos: this.sexos },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getAllPacientes();
      if (result) {
        this.idUser = result
/*         this._userService.create(this.token, result.usuario).subscribe(
          (response) => {
            console.log(response);
            this.status_user = response.status;
            if (this.status_user !== "success") {
              this.status_user = "error";
              if (response.code === 400) {
                alert(
                  "It was not possible to add the user because: " + response.msg
                );
              } else {
                alert(
                  "Error! Something went wrong, it was not possible to add the user"
                );
              }
            } else {
              this.idUser = response.user.id;
              if (this.idUser) {
                $("#modalNotes").modal("show");
              }
              let categories = {
                user_id: response.user.id,
                category_id: JSON.stringify(result.categories),
              };
              console.log(categories);
              this._cattegorieServices.linkUserCategories(categories).subscribe(
                (respuesta) => {
                  if (respuesta.status === "success") {
                    console.log("Categorias Agregadas Exitosamente!");
                  } else {
                    console.log("Error al cargar categorias!");
                  }
                },
                (error) => {
                  console.log("Error al cargar categorias!");
                }
              );
              let userid = {
                name: "mad",
                value: response.user.id,
              };

              if (response.hasfolder == null) {
                let folderNEw = new Folder(
                  1,
                  response.user.companyLinked.name,
                  "",
                  "",
                  userid,
                  "",
                  0,
                  0,
                  1,
                  0
                );
                console.log(folderNEw);
                this._folderService.create(this.token, folderNEw).subscribe(
                  (response) => {
                    console.log(response);
                    this.status_user = response.status;

                    if (this.status_user !== "success") {
                      // this.status_user = 'error';
                    } else {
                      // this.showSwal('success-message');
                      console.log("folder created");
                    }
                  },
                  (error) => {
                    console.log(<any>error);
                  }
                );
              }

              this.showSwal("success-message");
              // this.animal = result;
              this.getAllPacientes();
            }
          },
          (error) => {
            console.log(<any>error);
          }
        ); */
      }
    });
  }

  getAllPacientes() {
    this.cargando = true;
    this.customers = [];
    this._userService
      .getAllUsersType(this.token, "customer", 1, "ALL", this.activos, 1)
      .subscribe(
        (response) => {
          console.log(response);
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status === "success") {
            
            for (let element of response.data) {
              let promedio =
                (element.customerPricing +
                  element.customerResponseTime +
                  element.customerPaymentOnTime +
                  element.customerEasyToWorkWith) /
                4;
              this.customers.push([
                element.id,
                element.managedByString,
                element.companyLinked_name,
                element.name + " " + element.surname,
                element.country,
                element.email,
                promedio,
                element.activo,
                element.createdAt,
                element.companyLinked_alias,
                element.chatlog,
              ]);
            }
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.cargando = false;
        },
        (error) => {
          this.cargando = false;
          console.log(<any>error);
        }
      );
  }

  listUserCategories() {
    this.cargando = true;
    this.customers = [];

    var sendCategories = JSON.parse(JSON.stringify(this.userCategories));
    let index = 0;
    for (let cat of sendCategories) {
      for (let item of this.categories) {
        if (cat === item.id && item.sub.length > 0) {
          sendCategories.splice(index, 1);
          break;
        }
      }
      index++;
    }
    let json;
    json = {
      categories: JSON.stringify(sendCategories),
    };
    this._cattegorieServices.listUserCategories(json).subscribe(
      (response) => {
        console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          response.data.forEach(
            function (element) {
              let nameCompany = "";
              if (element.companyLinked != null) {
                nameCompany = element.companyLinked.name;
              }
              let promedio =
                (element.customerPricing +
                  element.customerResponseTime +
                  element.customerPaymentOnTime +
                  element.customerEasyToWorkWith) /
                4;
              /*this.customers.push([
                element.id,
                element.managedByString,
                nameCompany,
                element.name + " " + element.surname,
                element.country,
                element.email,
                promedio,
                element.activo,
              ]);*/

              this.customers.push([
                element.id,
                element.managedByString,
                element.companyLinked_name,
                element.name + " " + element.surname,
                element.country,
                element.email,
                promedio,
                element.activo,
                element.createdAt,
                element.companyLinked_alias,
                element.chatlog,
              ]);
            }.bind(this)
          );
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
        this.cargando = false;
      },
      (error) => {
        this.cargando = false;
        console.log(<any>error);
      }
    );
  }

  deleteFolderfirst(folder) {
    swal.fire({
      title: "",
      text:
        "Do you want to make this customer " +
        (this.activos === 1 ? "inactive" : "active"),
   
      showCancelButton: true,
      buttonsStyling: false,
 
      customClass:{
    confirmButton: 'btn btn-warning',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(
      function (result) {
        if (result.value) {
          this._userService.deleteUser(this.token, folder).subscribe(
            (response) => {
              console.log(response);
              if (response.status === "success") {
                this.getCustomers();
                this.mtds.notifySuccess(
                  this.activos === 1
                    ? "Customer status has been changed to customer"
                    : "Customer status has been changed to active"
                );
              } else {
                this.mtds.notifyError(response.msg, response.code);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
        }
      }.bind(this)
    );
  }
}

@Component({
  selector: "registro-paciente",
  templateUrl: "./nuevo-cliente/nuevo-cliente.component.html",
  styleUrls: ["./nuevo-cliente/nuevo-cliente.component.css"],
  providers: [
    UserService,
    CompanylinkedService,
    CategoriesService,
    LocationService,
  ],
})
export class NuevoPaciente {
  public mtds: Methods = new Methods();

  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public companySelected = null;
  public companies;
  public company;
  public allCategories;
  public categories: any[] = [];
  public userCategories: number[] = [];
  public companyLinked = null;
  public companyLocations: any[] = [];
  public idUser: any = "";

  sexos = [
    { value: "0", viewValue: "Female" },
    { value: "1", viewValue: "Male" },
    { value: "2", viewValue: "Other" },
  ];

  frequencies = [
    { value: "DAILY", viewValue: "Daily" },
    { value: "WEEKLY", viewValue: "Weekly" },
    { value: "MONTHLY", viewValue: "Monthly" },
    { value: "NEVER", viewValue: "Never" },
  ];

  cities = [
    { value: "paris-0", viewValue: "Paris" },
    { value: "miami-1", viewValue: "Miami" },
    { value: "bucharest-2", viewValue: "Bucharest" },
    { value: "new-york-3", viewValue: "New York" },
    { value: "london-4", viewValue: "London" },
    { value: "barcelona-5", viewValue: "Barcelona" },
    { value: "moscow-6", viewValue: "Moscow" },
  ];

  constructor( private _folderService: FolderService,
    public dialogRef: MatDialogRef<NuevoPaciente>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _companylinkedService: CompanylinkedService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _locationService: LocationService,
    public dialog: MatDialog,
    private _cattegorieServices: CategoriesService
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.getAllCompanies();
    this.getCategories();
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  public buscandoCompanies = false;
  getAllCompanies() {
    this.buscandoCompanies = true;
    this._companylinkedService.getAllCompaniesLite(this.token, "all").subscribe(
      (response) => {
        console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.companies = response.data;
          console.log(this.companies);
          if (this.data.company) {
            this.changeCompany({ id: this.data.company });
          }
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.buscandoCompanies = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        console.log(<any>error);
        this.buscandoCompanies = false;
      }
    );
  }

  getCategories() {
    this._cattegorieServices.showAll().subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.allCategories = response.data;
          for (let item of response.data) {
            if (item.father === 0) {
              let padre = {
                id: item.id,
                father: item.father,
                name: item.name,
                sub: [],
              };
              this.categories.push(padre);
            }
          }

          for (let item of response.data) {
            if (item.father !== 0) {
              let hijo = {
                id: item.id,
                father: item.father,
                name: item.name,
              };
              for (let i of this.categories) {
                if (i.id === hijo.father) {
                  i.sub.push(hijo);
                  break;
                }
              }
            }
          }

          // for (let item of this.categories) {

          //   let hijo = {
          //     id: 0,
          //     father: item.id,
          //     name: 'All'
          //   };

          //   if (item.sub.length > 1) {
          //     item.sub.unshift(hijo);
          //   }
          // }
          // console.log('Aquie merengues');
          // console.log(this.categories);
        } else {
          console.log("Error!");
        }
      },
      (error) => {
        console.log("Error!");
      }
    );
  }

  checkedAll(category_id) {
    for (let itemCat of this.allCategories) {
      if (!this.isAdded(itemCat.id) && itemCat.father === category_id) {
        return false;
      }
    }

    return true;
  }

  addCategoire(category, evento) {
    if (category.name !== "All") {
      if (!evento.checked) {
        let index = 0;
        for (let item of this.userCategories) {
          if (item === category.id) {
            this.userCategories.splice(index, 1);
          }
          index++;
        }
        console.log(category.father);
        if (category.father === 0) {
          for (let itemCat of this.allCategories) {
            if (this.isAdded(itemCat.id) && itemCat.father === category.id) {
              let index = 0;
              for (let i of this.userCategories) {
                if (itemCat.id === i) {
                  this.userCategories.splice(index, 1);
                  break;
                }
                index++;
              }
            }
          }
        }
      } else {
        this.userCategories.push(category.id);
      }
    } else if (category.name === "All" && !evento.checked) {
      for (let itemCat of this.allCategories) {
        if (this.isAdded(itemCat.id) && itemCat.father === category.father) {
          let index = 0;
          for (let i of this.userCategories) {
            if (itemCat.id === i) {
              this.userCategories.splice(index, 1);
              break;
            }
            index++;
          }
        }
      }
    } else if (category.name === "All" && evento.checked) {
      for (let itemCat of this.allCategories) {
        if (!this.isAdded(itemCat.id) && itemCat.father === category.father) {
          this.userCategories.push(itemCat.id);
        }
      }
    }

    console.log(this.userCategories);
  }

  isCheked(category) {
    if (category.name === "All") {
      return this.checkAll(category);
    } else {
      return this.isAdded(category.id);
    }
  }

  checkAll(category) {
    for (let item of this.categories) {
      if (item.id === category.father) {
        for (let i of item.sub) {
          if (!this.isAdded(i.id)) {
            return false;
          }
        }
        return true;
      }
    }
  }

  isAdded(id) {
    for (let i of this.userCategories) {
      if (id === i) {
        return true;
      }
    }
    return false;
  }

  ngOnInit() {
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    }
  }

  openNuevoCompany(): void {
    this.company = new CompanyLinked(
      1,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      1,
      0,
      "",
      "",
      "",
      "",
      "",
      0,
      0,
      0,
      0
    );
    let dialogRef = this.dialog.open(NuevoCompany, {
      width: "80%",
      data: { user: this.company },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this._companylinkedService.create(this.token, result).subscribe(
          (response) => {
            console.log(response);
            this.status_user = response.status;

            if (this.status_user != "success") {
              this.status_user = "error";
            } else {
              this.companySelected = response.company.id;
              this.getAllCompanies();
              this.data.user.companyLinked = {
                id: this.companySelected,
              };
            }
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
            console.log(<any>error);
          }
        );
      }
    });
  }

  getCompanyLocations(company_id) {
    this._locationService
      .getLocationsByCompany(this.token, company_id)
      .subscribe((r) => {
        console.log(r);
        this.companyLocations = r.data;
      });
  }

  changeLocation() {
    let flat = false;
    if (this.data.user.locationId != null) {
      for (let loc of this.companyLocations) {
        if (this.data.user.locationId == loc.id) {
          console.log(loc);

          this.data.user.address = loc.address;
          this.data.user.address2 = loc.address2;
          this.data.user.country = loc.country;
          this.data.user.colonia = loc.colonia;
          this.data.user.city = loc.city;
          this.data.user.zipCode = loc.zipCode;
          flat = true;
          break;
        }
      }
    }

    if (!flat) {
      console.log(this.companyLinked);
      this.data.user.address = this.companyLinked.address;
      this.data.user.address2 = this.companyLinked.address2;
      this.data.user.country = this.companyLinked.country;
      this.data.user.colonia = this.companyLinked.colonia;
      this.data.user.city = this.companyLinked.city;
      this.data.user.zipCode = this.companyLinked.zipCode;
    }
  }

  public companyName = "";

  changeCompany(e) {
    console.log(e);
    if (e.id) {
      this.companySelected = e.id;

      this.data.user.companyLinked = {
        id: this.companySelected,
      };
      console.log(this.data.user.companyLinked);
      this._companylinkedService
        .getCompany(this.token, this.companySelected)
        .subscribe(
          (response) => {
            console.log(response.data);
            this.companyName = response.data.name;
            this.data.user.address = response.data.address;
            this.data.user.address2 = response.data.address2;
            this.data.user.city = response.data.city;
            this.data.user.colonia = response.data.colonia;
            this.data.user.zipCode = response.data.zipCode;
            this.data.user.country = response.data.country;
            this.data.user.phone = response.data.phone;
            this.data.user.mobilePhone = response.data.mobilePhone;

            this.companyLinked = response.data;
            this.data.user.locationId = null;
            this.getCompanyLocations(this.companyLinked.id);
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
            console.log(<any>error);
          }
        );
    }
  }
  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
  closeModal() {
    this._userService.create(this.token, this.data.user).subscribe(
      (response) => {
        console.log(response);
        this.status_user = response.status;
        if (this.status_user !== "success") {
          this.status_user = "error";
          if (response.code === 400) {
            this.showToast('error', "It was not possible to add the user because: " + response.msg, 4000)
          } else {
            this.showToast('error', 'Error! Something went wrong, it was not possible to add the user.', 2000)
            this.dialogRef.close();
          }
        } else {
          this.showToast('success', 'Customer successfully added!', 2000)
          this.dialogRef.close(response.user.id);
          this.idUser = response.user.id;

          if (this.idUser) {
            $("#modalNotes").modal("show");
          }
          let categories = {
            user_id: response.user.id,
            category_id: JSON.stringify(this.userCategories),
          };
          console.log(categories);
          this._cattegorieServices.linkUserCategories(categories).subscribe(
            (respuesta) => {
              if (respuesta.status === "success") {
                console.log("Categorias Agregadas Exitosamente!");
              } else {
                console.log("Error al cargar categorias!");
              }
            },
            (error) => {
              console.log("Error al cargar categorias!");
            }
          );
          let userid = {
            name: "mad",
            value: response.user.id,
          };

          if (response.hasfolder == null) {
            let folderNEw = new Folder(
              1,
              response.user.companyLinked.name,
              "",
              "",
              userid,
              "",
              0,
              0,
              1,
              0
            );

            this._folderService.create(this.token, folderNEw).subscribe(
              (response) => {
                console.log(response);
                this.status_user = response.status;

                if (this.status_user !== "success") {
                  // this.status_user = 'error';
                } else {
                  // this.showSwal('success-message');
                  console.log("folder created");
                }
              },
              (error) => {
                console.log(<any>error);
              }
            );
          }
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  closeM() {
    $("#modalNotes").modal("hide");

    this.idUser = "";
  }
}
